<nz-spin nzTip="Cargando..." [nzSpinning]="loading" [nzSize]="'large'">
  <dx-tree-list id="treeView"
                [dataSource]="dataSource"
                [showColumnLines]="false"
                (onSelectionChanged)="onSelectionChange($event)"
                parentIdExpr="parentId"
                keyExpr="id"
                [showColumnHeaders]="false"
                noDataText="Cargando estructura..."
                style="font-family: 'Poppins', sans-serif;"
  >
    <dxi-column dataField="name" [caption]="projectTitle" cellTemplate="titleTemplate"></dxi-column>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-search-panel [visible]="false" [(text)]="searchValue" >
    </dxo-search-panel>
    <dxo-scrolling mode="virtual">
    </dxo-scrolling>

    <div *dxTemplate="let options of 'titleTemplate'">
      <span *ngIf="options.data.type === 'Package' && options.data.isBatchProduction" nz-icon nzType="diazar:clusterIcon"
        style="font-size: 18px;"></span>
      <span *ngIf="options.data.type === 'Activity'" nz-icon nzType="diazar:activityIcon" style="font-size: 18px;"></span>
      <span *ngIf="options.data.type === 'Package' && !options.data.isBatchProduction" nz-icon nzType="diazar:packageIcon"
        style="font-size: 18px;"></span>
      {{options.data.name}}
    </div>
  </dx-tree-list>
</nz-spin>
